var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnzoom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Compress") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Compress",
    transform: "translate(-2.000000, -2.000000)",
    stroke: "#B7844D"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.02295213,12.7073801 L1.16162305,19.1165552 L6.87993781,19.1165552 L0.5,19.5 L0.5,13.1216279 L0.882010826,18.8456574 L7.02295213,12.7073801 Z",
    id: "Fill-1",
    transform: "translate(4.000000, 16.000000) rotate(180.000000) translate(-4.000000, -16.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.87922288,0.5 L1.15465599,0.882010826 L7.29277478,7.02309002 L0.882681886,1.16186074 L0.882681886,6.87993781 L0.5,0.5 L6.87922288,0.5 Z",
    id: "Fill-2",
    transform: "translate(4.000000, 4.000000) rotate(180.000000) translate(-4.000000, -4.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,0.5 L19.5,6.87922288 L19.1189105,1.1558572 L12.9768008,7.29299939 L18.8392,0.883604289 L13.1200622,0.883604289 L19.5,0.5 Z",
    id: "Fill-3",
    transform: "translate(16.000000, 4.000000) rotate(180.000000) translate(-16.000000, -4.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7071845,12.9769099 L19.1165552,18.8382375 L19.1165552,13.1200622 L19.5,13.1200622 L19.5,19.5 L13.1216279,19.5 L13.1216279,19.1189105 L18.8455181,19.1189105 L12.7071845,12.9769099 Z",
    id: "Fill-4",
    transform: "translate(16.000000, 16.000000) rotate(180.000000) translate(-16.000000, -16.000000) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnzoom);
export default __webpack_public_path__ + "static/media/Unzoom.7688a44571cbbacb3b27c90be6d96e2c.svg";
export { ForwardRef as ReactComponent };